import {layerPositionPatch} from './layer-edit.js';

// Keep the pointer-down coordinate system throughout a drag. Selection controls
// or viewport layout changes must not become part of the customer's movement.
export function layerDragPosition(origin,start,point,inverse) {
  if(!origin||!start||!point||!inverse||![origin.x,origin.y,start.x,start.y,point.x,point.y,inverse.a,inverse.b,inverse.c,inverse.d].every(Number.isFinite))return{};
  const dx=point.x-start.x,dy=point.y-start.y;
  return layerPositionPatch(origin,inverse.a*dx+inverse.c*dy,inverse.b*dx+inverse.d*dy);
}

// Deletion is an intentional horizontal drag beyond the nail, not a small
// positional adjustment, resize, pinch, or swipe on the empty canvas.
export function layerDeleteSide(start, point, bounds) {
  if (!start || !point || !bounds) return null;
  const dx = point.x - start.x, dy = point.y - start.y;
  if (Math.abs(dx) < 64 || Math.abs(dx) < Math.abs(dy) * 1.35) return null;
  const margin = Math.max(28, Math.min(48, bounds.width * .16));
  if (dx < 0 && point.x < bounds.left - margin) return 'left';
  if (dx > 0 && point.x > bounds.right + margin) return 'right';
  return null;
}
